import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import SkillsSection from "./SkillsSection";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/personal.png";
import Clients from "./Clients";
import Contact from "../Contact/Contact";

function About() {
  return (
    <>
      {" "}
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                Beyond the <strong className="purple">Code</strong>
              </h1>
              <Aboutcard />
            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <img src={laptopImg} alt="about" className="img-fluid" />
            </Col>
          </Row>
          <SkillsSection />

          <Clients />

          <Github />

          <Contact />
        </Container>
      </Container>
    </>
  );
}

export default About;
